import React from "react"
import { useTranslation } from "react-i18next"

import FormSearch from "@molecules/FormSearch/FormSearch"

import styles from "./Search.module.scss"

const Search = ({ currentLanguage }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.search}>
      <h2 className="screen-reader-text">{t("Site search")}</h2>
      <FormSearch currentLanguage={currentLanguage} />
    </div>
  )
}

export default Search
